import { Component, Inject, OnInit } from '@angular/core';
import { BaseComponent } from '../base-component/base.component';
import { FormGroup } from '@angular/forms';
import { FieldGroup } from '@shared/interfaces/field.interface';
import { COMPLETE_INFORMATION_FORM } from '@shared-features/forms/complete-information.form';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerAPI } from '@features/customers/services/customer-api';
import { FunctionUtil } from '@shared/utils';
import { Customer } from '@features/customers/models/customer.model';
import { LanguageService } from '@core/services';
import { LanguageEnum } from '@shared/enums';

@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss'],
})
export class InformationDialogComponent extends BaseComponent implements OnInit {
  formGroup: FormGroup = new FormGroup({});

  fieldsGroup: FieldGroup = COMPLETE_INFORMATION_FORM;
  patchedFormValue: Record<string, any>;
  isRtl = false;
  constructor(
    public dialogRef: MatDialogRef<InformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Partial<Customer>,
    private customerAPI: CustomerAPI,
    private languageService: LanguageService
  ) {
    super();
  }

  ngOnInit() {
    this.languageService.currentLanguage$.subscribe((lang) => {
      this.isRtl = lang.isoCode === LanguageEnum.Arabic;
    });
    this.patchedFormValue = {
      CompanyName: this.data?.title || '',
      VATNumber: this.data?.vatNumber || '',
      CRNumber: this.data?.crNumber || '',
    };
  }

  saveCustomerData() {
    const payload = {
      id: this.data?.id,
      vatNumber: this.formGroup.get('VATNumber')?.value,
      title: this.formGroup.get('CompanyName')?.value,
      crNumber: this.formGroup.get('CRNumber')?.value,
    };
    const customerPayload = FunctionUtil.getObjectDiff(this.data, payload, ['id']);
    this.load(this.customerAPI.updateCustomer(customerPayload)).subscribe((res) => {
      this.dialogRef.close(res);
      this.showSuccessMessage('SuccessMessages.InformationUpdatedSuccessfully');
    });
  }
}
